export default { 
  adminTypeTrade: [],
  adminWallet: {}
}